import { api } from '../../../../../services/api'

export const pedidosService = {
  async confirmarPedido(id, status, codusu) {
    const response = await api.put('/site/v2/tercerizado/confirmacao-pedido-tercerizado', {
      id_pedido: id,
      status: status, // 'S' para aprovar, 'N' para recusar
      codigo_usuario: codusu,
    })
    return response.data
  },

  async editarPedido(data) {
    const response = await api.put('/site/v2/tercerizado/edita-pedido-tercerizado', data)
    return response.data
  },
}
